import { ETraitsTypes } from 'Shared/types';
import { EProvider } from 'Common/consts';
import { getTableColumns as getBinaryColumnsGLR, getWesWgsTableColumns as getBinaryWesWgsColumnsGLR, } from './binary';
import { getTableColumns as getContinuousColumnsGLR, getWesWgsTableColumns as getContinuousWesWgsColumnsGLR, } from './continuous';
import { TABLE_COLUMNS_DESCRIPTIONS as UKB_BINARY_COLUMNS_DESCRIPTIONS } from './binaryUKB';
import { TABLE_COLUMNS_DESCRIPTIONS as UKB_CONTINUOUS_COLUMNS_DESCRIPTIONS } from './continuousUKB';
/**
 * Get table columns
 *
 * @param props - an object with the following fields:
 * - traitsType - Traits type
 * - providerId - Id of provider
 * - referrerData - Referrer data for the variant link
 * - columnsData - Additional data for the variant link
 * - areForExport - Boolean value which identify getting columns for UI or for exports file
 * - hasAncestryData - Boolean value which determines if ancestry data exists
 * @returns formatted table columns
 */
export const getColumns = ({ traitsType, providerId, referrerData, columnsData, areForExport, isCurrentDatasetWesOrWgs, hasAncestryData, }) => {
    const columnsMapper = {
        [ETraitsTypes.Binary]: {
            [EProvider.FinnGen]: getBinaryColumnsGLR({}, referrerData, columnsData),
            [EProvider.UKB]: isCurrentDatasetWesOrWgs
                ? getBinaryWesWgsColumnsGLR(UKB_BINARY_COLUMNS_DESCRIPTIONS, referrerData)
                : getBinaryColumnsGLR(UKB_BINARY_COLUMNS_DESCRIPTIONS, referrerData, columnsData, hasAncestryData),
        },
        [ETraitsTypes.Continuous]: {
            [EProvider.FinnGen]: getContinuousColumnsGLR({}, referrerData, columnsData),
            [EProvider.UKB]: isCurrentDatasetWesOrWgs
                ? getContinuousWesWgsColumnsGLR(UKB_CONTINUOUS_COLUMNS_DESCRIPTIONS, referrerData)
                : getContinuousColumnsGLR(UKB_CONTINUOUS_COLUMNS_DESCRIPTIONS, referrerData, columnsData, hasAncestryData),
        },
    };
    const baseColumns = columnsMapper[traitsType][providerId];
    if (!FEATURE_FLAGS.QV_LINKS_ENABLED && !areForExport) {
        return baseColumns.slice(1);
    }
    return baseColumns;
};
